import LazyLoad from "vanilla-lazyload";
import lazyLoad from "./components/lazyLoad";
import ScrollToTop from "./components/scrollToTop";
import MobileBurgerMenu from "./components/mobileBurgerMenu";
import coverTable from "./components/coverTable";
import loadGame from "./components/loadGame";
import tabs from "./components/tabs";

document.addEventListener( 'DOMContentLoaded', function () {

	lazyLoad();

	let myLazyLoad = new LazyLoad();

	ScrollToTop();

	MobileBurgerMenu();

	// adaptive table class
	coverTable();

	// iframe on click
	loadGame();

	tabs( ".pros-cons" );
	tabs( ".custom-faq" );

} );

// import custom scripts
import './custom-app'
